module.exports = __webpack_public_path__ + "img/house-flood.ab941c6c.svg";